/* eslint-disable @typescript-eslint/no-explicit-any */
import { getRequest } from '../../../services/httpService';


export interface DayData {
  disposition?: string;
  oocyte_grade?: string;
  pn?: string;
  pb?: string;
  number_of_cells?: number;
  grade?: string;
  stage?: string;
}

export interface SumationData{
  [key: string]: number;
  blast:number;
  cleaved:number;
  discarded:number;
  fertilized:number;
  freezed:number;
  gv:number;
  mi:number;
  mii:number;
  transferred:number;
}
export function getputSemenProcessingPreProcessUrl(cycle_id: number): string {
  return `embryo/summary/${cycle_id}`; 
}
  

export function getSemenProcessingPreProcesss(cycle_id: number): Promise<any> {
  return getRequest(getputSemenProcessingPreProcessUrl(cycle_id)); 
}